import styled from 'styled-components';
import ClosePopupSvg from './crosspopup.svg';

const ClosePopupIcon = styled(ClosePopupSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || ''};
  height: ${props => props.height || ''};
  fill: ${props => props.fill || '#647a97'};
  
`;

export default ClosePopupIcon;
